<!-- @format -->

@if (settings?.customerServiceEmail) {
  <a [href]="'mailto:' + settings.customerServiceEmail">{{ settings.customerServiceEmail }}</a>
}
@if (settings?.customerServiceUrl | localizedString; as customerServiceUrl) {
  @if (!settings.customerServiceEmail) {
    <a fudisLink [title]="customerServiceUrl" [href]="customerServiceUrl" [external]="true"></a>
  }
}
